"use client";

import Image from "next/image";
import { CSSProperties, useEffect, useState } from "react";

import LoaderWhite from "./loader-white.svg";
import Loader from "./loader-alt.svg";
import styles from "./Spinner.module.scss";

interface Props {
  negative?: boolean;
  style?: CSSProperties;
}

export default function Spinner(props: Props) {
  const { negative, style } = props;
  const [loader, setLoader] = useState(Loader);

  useEffect(() => {
    if (negative) {
      setLoader(LoaderWhite);
    } else {
      setLoader(Loader);
    }
  }, [negative]);

  return (
    <Image
      src={loader}
      width={16}
      height={16}
      alt="Loading"
      className={styles.spinner}
      style={style}
    />
  );
}
